export const bookingCharges = {
  header: {
    title: "Frais",
    titleNew: "Nouveaux frais",
    sub: "Éléments à inclure sur la facture du client.",
    subNew:
      "Pour la prochaine facture. L'hébergement déjà facturé est affiché ci-dessus, sur sa facture.",
  },
  loading: "Chargement des frais…",
  empty: {
    title: "Aucun frais enregistré",
    titleBilled: "Aucun frais en attente",
    sub: "Ajoutez l'hébergement, le ménage, des extras ou d'autres services.",
    subBilled: "Ajoutez un frais pour créer une autre facture pour cette réservation.",
  },
  buttons: {
    addCharge: "Ajouter un frais",
    addFirstCharge: "Ajouter le premier frais",
    manage: "Gérer",
    manageTemplatesTitle: "Gérer les modèles",
    add: "Ajouter",
    close: "Fermer",
    cancel: "Annuler",
    saving: "Enregistrement…",
    saveCharge: "Enregistrer le frais",
    saveChanges: "Enregistrer les modifications",
    deleting: "Suppression…",
    confirmDelete: "Oui, supprimer",
    editTitle: "Modifier",
    deleteTitle: "Supprimer",
  },
  table: {
    item: "Article",
    qty: "Qté",
    unitPrice: "Prix unitaire",
    vat: "TVA",
    total: "Total",
  },
  chips: {
    lodging: "Hébergement",
    discount: "Remise",
    autoSynced: "Synchronisé automatiquement",
  },
  // Resumen de la estancia bajo cada habitación.
  stay: {
    nights: "1 nuit | {n} nuits",
    rooms: "1 chambre | {n} chambres",
  },

  fields: {
    // De qué habitación es el cargo (reservas de varias habitaciones).
    room: "Chambre",
    roomAll: "Toute la réservation",
    roomHint: "S'il concerne une chambre, il ira sur la facture de cette chambre.",
    date: "Date",
    category: "Catégorie",
    quantity: "Quantité",
    unitPriceFull: "Prix unitaire",
    vatPct: "TVA (%)",
    name: "Nom",
    price: "Prix",
    internalNotes: "Notes internes",
    paymentMethod: "Moyen de paiement",
    paymentDate: "Date de paiement",
    guestCount: "Nombre de clients",
  },
  placeholders: {
    item: "Sélectionnez ou saisissez un article…",
    egCleaning: "ex. Ménage",
    internalNote: "Ajouter une note interne…",
  },
  templates: {
    savedTitle: "Frais enregistrés",
    noResults: 'Aucun résultat pour « {query} »',
    emptyPre: "Aucun frais enregistré. ",
    createOne: "Créez-en un",
    manageTitle: "Frais personnalisés",
    manageSub: "Créez des frais réutilisables pour vos factures.",
    emptyList: "Aucun frais enregistré. Ajoutez le premier ci-dessus.",
    noCategory: "Aucune catégorie",
  },
  vat: {
    labelPct: "TVA {rate} %",
  },
  modal: {
    editTitle: "Modifier le frais",
    addSub: "Nouvel article pour la facture",
    editSub: "Modifier les détails du frais",
    totalCalculated: "Total calculé",
  },
  common: {
    optional: "(facultatif)",
    unspecified: "Non spécifié",
  },
  invoice: {
    sectionLabel: "Facture électronique",
  },
  footer: {
    pending: "En attente de facturation",
    totalDue: "Total dû",
  },
  deleteModal: {
    title: "Supprimer le frais ?",
    sub: "Cette action est irréversible.",
  },
  autoCategory: {
    service: "Service",
    fee: "Frais",
    extraGuest: "Client supplémentaire",
    tax: "Taxe",
    cityTax: "Taxe de séjour",
    adjustment: "Ajustement",
    autoFallback: "Frais automatique",
  },
  chargeBasis: {
    percentOfTotal: "Pourcentage du total",
    perNight: "Par nuit",
    perPerson: "Par personne",
    perPersonPerNight: "Par personne et par nuit",
    perStay: "Par réservation",
  },
  toast: {
    descRequired: "La description est obligatoire.",
    chargeAdded: "Frais ajouté.",
    chargeUpdated: "Frais mis à jour.",
    chargeDeleted: "Frais supprimé.",
    chargeSaved: "Frais enregistré.",
    saveFailed: "Impossible d'enregistrer.",
    deleteFailed: "Impossible de supprimer.",
    warningTitle: "Avertissement",
    doneTitle: "Terminé",
    errorTitle: "Erreur",
  },
  invoices: {
    title: "Factures émises",
    noName: "Sans nom",
    conceptCount: "{count} article | {count} articles",
    viewPdf: "Voir le PDF",
    sendWhatsapp: "Envoyer via WhatsApp",
    correct: "Corriger (rectificative)",
    void: "Annuler (facture rectificative)",
    conceptsFoot:
      "Ces articles sont déjà facturés. Le PDF contient le détail complet.",
  },
  status: {
    draft: "Brouillon",
    sent: "Émise",
    processing: "En cours de traitement",
    pending: "En attente",
    error: "Erreur",
    corrected: "Corrigée",
    voided: "Annulée",
  },
  checkinModal: {
    title: "Détails de l'enregistrement",
    bookingLink: "Réservation #{code}",
    requestDate: "Date de la demande : {date} à {time}",
  },
  payment: {
    desti: "Paiement sur place",
    efect: "Espèces",
    movil: "Paiement mobile",
    otro: "Autres moyens de paiement",
    platf: "Plateforme de paiement",
    tarjt: "Carte de crédit",
    trans: "Virement bancaire",
    treg: "Carte cadeau",
  },
};
